// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__jPNfj","tab":"Tabs_tab__zssZh","tabActive":"Tabs_tabActive__5cam4"};